import axiosInstance from "../../axiosConfig";
import { TOAST_TYPES_ENUM } from "../../enums";
import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import { Toast } from "../../shared";

interface VerifyRegistrationTokenParams {
  token: string;
}

interface VerifyRegistrationTokenResponse {
  message: string;
  user: {
    name: string;
    email: string;
  };
}

export const useVerifyRegistrationToken = (
  options?: UseMutationOptions<
    VerifyRegistrationTokenResponse,
    Error,
    VerifyRegistrationTokenParams
  >
) => {
  return useMutation({
    mutationKey: ["verifyRegistrationToken"],
    mutationFn: async (params: VerifyRegistrationTokenParams) => {
      return axiosInstance
        .post(`/verify-registration-token`, params)
        .then((res) => res.data);
    },
    onSuccess: (data, variables, context) => {
      if (options && options.onSuccess) {
        options.onSuccess(data, variables, context);
      }
    },
    onError: (error: any, variables, context) => {
      Toast({
        message: error?.response?.data?.message || "Błąd weryfikacji tokenu",
        type: TOAST_TYPES_ENUM.ERROR,
        id: "verifyRegistrationToken",
      });
      if (options && options.onError) {
        options.onError(error, variables, context);
      }
    },
  });
};

interface ActivateWithPasswordParams {
  token: string;
  password: string;
}

interface ActivateWithPasswordResponse {
  message: string;
  userId: number;
}

export const useActivateWithPassword = (
  options?: UseMutationOptions<
    ActivateWithPasswordResponse,
    Error,
    ActivateWithPasswordParams
  >
) => {
  return useMutation({
    mutationKey: ["activateWithPassword"],
    mutationFn: async (params: ActivateWithPasswordParams) => {
      return axiosInstance
        .post(`/activate-with-password`, params)
        .then((res) => res.data);
    },
    onMutate: (variables) => {
      Toast({
        message: "Aktywacja konta...",
        type: TOAST_TYPES_ENUM.LOADING,
        id: "activateAccount",
      });
      if (options && options.onMutate) {
        return options.onMutate(variables);
      }
    },
    onSuccess: (data, variables, context) => {
      Toast({
        message: "Konto zostało aktywowane pomyślnie",
        type: TOAST_TYPES_ENUM.SUCCESS,
        id: "activateAccount",
      });
      if (options && options.onSuccess) {
        options.onSuccess(data, variables, context);
      }
    },
    onError: (error: any, variables, context) => {
      Toast({
        message:
          error?.response?.data?.message || "Błąd podczas aktywacji konta",
        type: TOAST_TYPES_ENUM.ERROR,
        id: "activateAccount",
      });
      if (options && options.onError) {
        options.onError(error, variables, context);
      }
    },
  });
};
